function getTop(props, initialValue) {

  const setGetTop = parseInt((initialValue * -props.scrollValue) + props.maxScroll);
  return setGetTop === 0 ? 1 : setGetTop;

}

export default getTop;
